export default {
  'invoice_confirmation.pdf.logo': 'Logo',
  'invoice_confirmation.pdf.name': 'Company Name',
  'invoice_confirmation.pdf.address': 'Address',
  'invoice_confirmation.pdf.addition_mark': 'Document Type',
  'invoice_confirmation.pdf.bill_to': 'BILL TO',
  'invoice_confirmation.pdf.ship_to': 'SHIP TO',
  'invoice_confirmation.pdf.invoice_no': 'INVOICE NO',
  'invoice_confirmation.pdf.INVOICE #': 'INVOICE NO',
  'invoice_confirmation.pdf.invoice_date': 'INVOICE DATE',
  'invoice_confirmation.pdf.cod_switch': 'COD',
  'invoice_confirmation.pdf.due_date': 'DUE DATE',
  'invoice_confirmation.pdf.due_upon_receipt': 'DUE UPON RECEIPT',
  'invoice_confirmation.pdf.shipment_number': 'FILE NO',
  'invoice_confirmation.pdf.ref_no': 'REF NO',
  'invoice_confirmation.pdf.show_shipment_info': 'Show Shipment Info',
  'invoice_confirmation.pdf.show_more_shipment_info': 'More',
  'invoice_confirmation.pdf.date': 'DATE',
  'invoice_confirmation.pdf.customer': 'CUSTOMER',
  'invoice_confirmation.pdf.op': 'OPERATOR',
  'invoice_confirmation.pdf.sales': 'SALES',
  'invoice_confirmation.pdf.delivery_location_name': 'DELIVERY LOCATION',
  'invoice_confirmation.pdf.delivery_location_country': 'COUNTRY',
  'invoice_confirmation.pdf.delivery_location_zip': 'POSTAL CODE',
  'invoice_confirmation.pdf.po_no': 'P.O. No.',
  'invoice_confirmation.pdf.mbl_no': 'MB/L No.',
  'invoice_confirmation.pdf.size': 'B/L NO',
  'invoice_confirmation.pdf.hbl_no_list': 'HB/L No.',
  'invoice_confirmation.pdf.por_etd': 'POR / ETD',
  'invoice_confirmation.pdf.pol_etd': 'POL / ETD',
  'invoice_confirmation.pdf.pod_eta': 'POD / ETA',
  'invoice_confirmation.pdf.shipper': 'SHIPPER',
  'invoice_confirmation.pdf.consignee': 'CONSIGNEE',
  'invoice_confirmation.pdf.del_eta': 'DEL / ETA',
  'invoice_confirmation.pdf.f_dest_eta': 'F.DEST. / ETA',
  'invoice_confirmation.pdf.notify': 'NOTIFY',
  'invoice_confirmation.pdf.commodity': 'COMMODITY',
  'invoice_confirmation.pdf.vessel': 'VESSEL / VOYAGE',
  'invoice_confirmation.pdf.incoterms': 'INCOTERMS',
  'invoice_confirmation.pdf.carrier_booking_no': 'CARRIER BKG NO.',
  'invoice_confirmation.pdf.number_pkg': 'CNTR. COUNT',
  'invoice_confirmation.pdf.container_no': 'CNTR. NO',
  'invoice_confirmation.pdf.containers_summary': 'VOLUME',
  'invoice_confirmation.pdf.code_description': 'FREIGHT DESCRIPTION',
  'invoice_confirmation.pdf.seal_number': 'FREIGHT DESCRIPTION',
  'invoice_confirmation.pdf.currency': 'CUR.',
  'invoice_confirmation.pdf.rate': 'RATE',
  'invoice_confirmation.pdf.vol': 'VOL.',
  'invoice_confirmation.pdf.unit': 'UNIT',
  'invoice_confirmation.pdf.ex_rate': 'EX-RATE',
  'invoice_confirmation.pdf.vat': 'VAT',
  'invoice_confirmation.pdf.sst': 'SST',
  'invoice_confirmation.pdf.gst': 'GST',
  'invoice_confirmation.pdf.sst_amount': 'SST AMT',
  'invoice_confirmation.pdf.gst_amount': 'GST AMT',
  'invoice_confirmation.pdf.wht': 'WHT',
  'invoice_confirmation.pdf.amount': 'AMOUNT',
  'invoice_confirmation.pdf.balance': 'BALANCE',
  'invoice_confirmation.pdf.amount_with_no_vat': 'NON VAT AMT',
  'invoice_confirmation.pdf.amount_with_vat': 'VAT AMT',
  'invoice_confirmation.pdf.subtotal_title': 'SUBTOTAL:',
  'invoice_confirmation.pdf.show_main_currency': 'Show Main Currency',
  'invoice_confirmation.pdf.show_local_currency': 'Show Main Currency',
  'invoice_confirmation.pdf.show_separate_tax_columns': 'Show Separate Tax Columns',
  'invoice_confirmation.pdf.sep_tax_columns': 'Show Separate Tax Columns',
  'invoice_confirmation.pdf.show_attachment': 'Show Attachment',
  'invoice_confirmation.pdf.total_before_wht': 'TOTAL AMOUNT:',
  'invoice_confirmation.pdf.wht_title': 'LESS WHT:',
  'invoice_confirmation.pdf.currency_total_title': 'TOTAL',
  'invoice_confirmation.pdf.local_currency_total_title': 'TOTAL:',
  'invoice_confirmation.pdf.remark': 'REMARK',
  'invoice_confirmation.pdf.attachment_options_select': 'ADD ATTACHMENT',
  'invoice_confirmation.pdf.memo': 'MEMO',
  'invoice_confirmation.pdf.sign': 'AUTHORIZED SIGNATURE',
  'invoice_confirmation.pdf.show_currency_rate': 'Currency Rate',
  'invoice_confirmation.pdf.currency_rates': 'Currency Rates',
  'invoice_confirmation.pdf.creator': 'PREPARED BY',
  'invoice_confirmation.pdf.total_text': 'TOTAL',
};
